const ar = {
  metaTitle: "SkillSynergy | المدونة",
  metaDescription:
    "ملاحظات حول البرمجة والذكاء الاصطناعي وتعلّم بناء البرمجيات، من مدربي SkillSynergy.",
  navLabel: "المدونة",
  eyebrow: "مقالات",
  title: "ملاحظات من قاعة الدرس",
  lead: "كتابات متفرقة عن البرمجة والذكاء الاصطناعي وما يستحق التعلّم فعلًا.",
  readTime: (minutes: number) => `${minutes} دقائق للقراءة`,
  backToBlog: "العودة إلى كل المقالات",
  publishedOn: "نُشر في",
  englishOnlyNotice: "هذه المقالة متاحة باللغة الإنجليزية فقط.",
  readMore: "اقرأ المقالة",
};

export default ar;
